<div class="filler container">
  <div class="mobile-flex">
    <div class="mobile-wrapper">
      <div class="row">
        <p class="title">{{boldText}}</p>
      </div>
      <div class="row ticker-hint" *ngIf="isTeam || isFromRegisterAsReporterCard">
        <div class="buttons">
          <a *ngIf="!hasReporter" class="btn-link" [href]="linkToRegisterClub">
            fan.at als Verein nutzen
          </a>
          <button *ngIf="!hasReporter" class="filler__become-reporter" mat-stroked-button color="primary"
                  (click)="onBecomeReporter()">
            <mat-icon>mic</mat-icon>
            Teamreporter werden
          </button>
          <button *ngIf="hasReporter" class="filler__become-reporter"
                  [class.invert]="true" mat-stroked-button color="primary"
                  (click)="onBecomeReporter()">
            <mat-icon>mic</mat-icon>
            Werde Reporter
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="buttons mobile">
    <a *ngIf="!hasReporter" class="btn-link" [href]="linkToRegisterClub">
      fan.at als Verein nutzen
    </a>
    <button *ngIf="!hasReporter" class="filler__become-reporter" mat-stroked-button color="primary"
            (click)="onBecomeReporter()">
      <mat-icon>mic</mat-icon>
      Teamreporter werden
    </button>
    <button *ngIf="hasReporter" class="filler__become-reporter" 
            [class.invert]="true" mat-stroked-button color="primary"
            (click)="onBecomeReporter()">
      <mat-icon>mic</mat-icon>
      Werde Reporter
    </button>
  </div>
</div>
